module.exports = __webpack_public_path__ + "media/icons/widget-raport-close@2x-cba5b7c7.png";